import _classCallCheck from "F:\\Dev\\VSS\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "F:\\Dev\\VSS\\node_modules\\@babel\\runtime/helpers/esm/createClass";

var Effect =
/*#__PURE__*/
function () {
  function Effect(context) {
    _classCallCheck(this, Effect);

    this.name = "effect";
    this.context = context;
    this.input = this.context.createGain();
    this.effect = null;
    this.bypassed = false;
    this.output = this.context.createGain();
    this.setup();
    this.wireUp();
  }

  _createClass(Effect, [{
    key: "bypass",
    value: function bypass(bool) {
      if (bool != this.bypassed) {
        this.bypassed = bool;

        if (bool) {
          this.input.disconnect(this.effect);
          this.input.connect(this.output);
        } else {
          this.input.disconnect(this.output);
          this.input.connect(this.effect);
        }
      }
    }
  }, {
    key: "setup",
    value: function setup() {
      this.effect = this.context.createGain();
    }
  }, {
    key: "wireUp",
    value: function wireUp() {
      this.input.connect(this.effect);
      this.effect.connect(this.output);
    }
  }, {
    key: "connect",
    value: function connect(destination) {
      this.output.connect(destination);
    }
  }]);

  return Effect;
}();

export { Effect as default };